import React from 'react';
import { Modal } from '@mantine/core';
import FormProcessUnblockCustomer from '../../forms/ProcessUnblockCustomerForm';
import PropTypes from 'prop-types';

const ModalProcessUnblockCustomer = ({
  modal = {
    type: 'accept',
    opened: false
  },
  setModal = () => {},
  handleSubmitProcess = () => {}
}) => {
  const onClose = () => setModal({
    type: modal.type,
    opened: false
  });

  return (
    <Modal centered onClose={onClose} opened={modal.opened} size="lg" title={`${modal.type === 'accept' ? 'Setujui' : 'Tolak'} Pengajuan Buka Blokir`}>
      <FormProcessUnblockCustomer handleSubmit={handleSubmitProcess}
        onCancel={onClose} type={modal.type}/>
    </Modal>
  );
};

export default ModalProcessUnblockCustomer;

ModalProcessUnblockCustomer.propTypes = {
  handleSubmitProcess: PropTypes.func,
  modal: PropTypes.object,
  setModal: PropTypes.func,
};
